import { Button, Intent } from "@blueprintjs/core"
import { useState } from "react"
import { DIALOG_SIZE, INVITE_TYPE } from "src/libs/interfaces/layouts"
import { ScalableDialog } from "src/libs/useful"
import ConfirmButton from "src/libs/useful/ConfirmButton"
import { __ } from "src/libs/utilities"
import { component_url } from "src/libs/utilities/links"
import actions from "src/modules/pe-basic-module/data/actions"
import { ADD_REQUEST_INVITE_ACTION, REMOVE_REQUEST_INVITE_ACTION } from "src/modules/pe-basic-module/data/actionTypes"
import { ILand, USER_EVENT_REQUEST_STATUS } from "src/modules/pe-fest-module/data/interfaces"
import InsertNewProject from "src/modules/pe-fest-module/views/about/InsertNewProject"
import { IState, IUser, useMainStore } from "src/settings/zustand"

interface IProps {
    item : ILand
    className?: string
    buttonClassName?: string
    onInvite?: (item: ILand) => void
}

const EventRequestForm = ({ item, ...props}:IProps) :JSX.Element => {
    
    const user:IUser = useMainStore((state:IState) =>state.user)
    const [isOpen, setIsOpen] = useState<boolean>(false) 
    const [isInsertOpen, setIsInsertOpen] = useState<boolean>(false) 
     
    const onClose = () => {
        setIsOpen(false)
    }

    const onRequest = (status: USER_EVENT_REQUEST_STATUS) => {
        if(!user.id) {
            useMainStore.setState({isOpenLogin: true})
            return
        }
        switch(status){
            case USER_EVENT_REQUEST_STATUS.NONE:
                actions(ADD_REQUEST_INVITE_ACTION,  {
                    user_id: user.id,
                    land_id: item.id
                })
                .then(res => {
                    console.log(res) 
                    if(props.onInvite) {
                        props.onInvite( res.land )
                    }
                })
                break
            case USER_EVENT_REQUEST_STATUS.WAITING:
                actions(REMOVE_REQUEST_INVITE_ACTION,  {
                    input: {
                        user_id: user.id,
                        land_id: item.id
                    }, 
                    land_id: item.id
                })
                .then(res => {
                    console.log(res) 
                    if(props.onInvite) {
                        props.onInvite( { ...item.land, invite_status: USER_EVENT_REQUEST_STATUS.NONE } as ILand )
                    }
                })
                break
        }
        
    }

    let btn: JSX.Element = <></> 
    if( [INVITE_TYPE.ONLY, INVITE_TYPE.MAY_BE].includes(item.invite_type || INVITE_TYPE.NONE) ) {
        switch(item.invite_status) {
            case USER_EVENT_REQUEST_STATUS.NONE:
                btn = <div className={` ${props.className}`}>
                    <ConfirmButton
                        buttonLarge
                        buttonLabel={__("Take part")}
                        buttonClassName={`${props.buttonClassName} h`}
                        buttonIntent={Intent.PRIMARY}
                        onConfirm={() => onRequest(USER_EVENT_REQUEST_STATUS.NONE)}
                        dialogClasssName={DIALOG_SIZE.MINIMAL}
                        yesLabel={__("Send Request")}
                        noLabel={__("Cancel")}
                    >   
                        <div className="p-4"> 
                            {__("Are you really send request?")} 
                        </div>
                    </ConfirmButton>  
                </div>
                break
            case USER_EVENT_REQUEST_STATUS.WAITING:
                btn = <div className={` ${props.className}`}>
                     <ConfirmButton
                        buttonLarge
                        buttonLabel={
                            <>
                                <div className={`small descr text-light text-center pt-0 pb-1 pe-surface3`}>
                                    <span className="opacity_5">
                                        {__("You have sent a request to participate")}
                                    </span>
                                </div>
                                <div className="text-center text-uppercase h">{__("Waiting access")}</div>
                                <div className={`small descr text-light text-center pt-0 pe-surface3`}>
                                    <span className="opacity_5">
                                        {__("Press for withdraw request")}
                                    </span>
                                </div>
                            </> 
                        }
                        buttonClassName={"px-3 py-2"}
                        buttonIntent={Intent.NONE}
                        onConfirm={() => onRequest(USER_EVENT_REQUEST_STATUS.WAITING)}
                        dialogClasssName={DIALOG_SIZE.MINIMAL}
                        yesLabel={__("Yes, revoke request")}
                        noLabel={__("Cancel")}
                    >
                        <div className="px-4 py-2">
                            <div className="p-3">
                                {__("Are you really want revoke your request?")}
                            </div>
                        </div>
                    </ConfirmButton>   
                </div>
                break
            case USER_EVENT_REQUEST_STATUS.AGREED: 
                btn = <div className={` ${props.className}`}>
                    <ConfirmButton
                        buttonLarge
                        buttonLabel={
                            <> 
                                <div className="text-center text-uppercase h">{__("You are invited")}</div> 
                            </> 
                        }
                        buttonClassName={`${props.buttonClassName} h px-5`}
                        buttonIntent={Intent.SUCCESS}
                        onConfirm={() => onRequest(USER_EVENT_REQUEST_STATUS.WAITING)}
                        dialogClasssName={DIALOG_SIZE.MINIMAL}
                        yesLabel={__("Yes, revoke request")}
                        noLabel={__("Cancel")}
                    >
                        <div className="p-4 text-center">
                            <div className="p-3">
                                {__("You are invited. The organizers are looking forward to your presence")}
                            </div>
                            <div className="p-3">
                                {__("Do you want to opt out?")}
                            </div>
                        </div>
                    </ConfirmButton>   
                </div> 
                break 
            case USER_EVENT_REQUEST_STATUS.WITHDRAWN:
            default:
                btn = <div className={` ${props.className}`}>
                    <Button large intent={Intent.DANGER} className={`${props.buttonClassName} h`} disabled>
                        {__("You are denied")}
                    </Button>
                </div>
                break
        }
    }
    else if( item.invite_type === INVITE_TYPE.NONE || !item.invite_type) {
        const link = `${component_url("FestivalView")}fest/${item.id}/insert-project`
         
         btn = <>
            <div className={` ${props.className}`}>
                <Button large intent={Intent.SUCCESS} className={`${props.buttonClassName} h`} onClick={() => setIsInsertOpen(true) }>
                    { __("Insert new Project") }
                </Button>
            </div>
            <ScalableDialog
                dialogSize={DIALOG_SIZE.LARGE}
                isOpen={isInsertOpen}
                hideClose={false}
                onClose={ () => setIsInsertOpen(false) }
            >
                <div className="max-height overflow-y-auto px-5">
                    <InsertNewProject landId={item.id} isStatusWorked />
                </div> 
            </ScalableDialog>
         </>
    }
    return <> 
        { btn }
        <ScalableDialog
            dialogSize={DIALOG_SIZE.FULL}
            isOpen={isOpen}
            hideClose={false}
            onClose={onClose}
            isCloseButtonShown
        >
            <div className=" h-100">
                <DialogContent type={item.invite_status} onClose={onClose} />
            </div> 
        </ScalableDialog>
    </>
} 
export default EventRequestForm

const DialogContent = ({ type, onClose, ...props }: any) :JSX.Element => {
    switch(type) {
        case USER_EVENT_REQUEST_STATUS.WAITING:
            return <div className="flex-centered h-100">
                <div className="small-container ">
                    <h4>
                        {__("Send request")}
                    </h4> 
                    <div className="my-4 text-larger">
                        {__("The request for participation has been sent. A response from the organizers is awaited")}
                    </div>
                </div>
            </div>
        case USER_EVENT_REQUEST_STATUS.AGREED:
            return <div className="flex-centered h-100">
                <div className="small-container ">
                    <h4>
                        {__("Send request")}
                    </h4> 
                    <div className="my-4 text-larger">
                        {__("You are invited. The organizers are looking forward to your presence")}
                    </div>
                </div>
            </div>
        case USER_EVENT_REQUEST_STATUS.NONE:
        default:
            return <div className="flex-centered h-100">
                <div className="small-container ">
                    <h4>
                        {__("Send request")}
                    </h4> 
                    <div className="my-4 text-larger">
                        {__("Send a request for participation to the organizers")}
                    </div>
                </div>
            </div>
    }
    
}